import type { ReactNode } from 'react';
import type { GroupTile } from '@casa/model';
import { useTileEnvironment } from '../../view/tile_environment.ts';
import { TileFrame } from '../../view/tile_frame.tsx';
import { tileStyleOf } from '../../view/tile_style.ts';

/**
 * A group (`group` tile): an empty box with its title. The screen draws groups behind every other
 * tile, so a group laid under tiles frames them. It is styled as any tile (dashboard-editor spec
 * §5.9, the owner: "common to all tile types, including group tiles").
 */
export function GroupTileView({ group }: { group: GroupTile }) : ReactNode {
    return <TileFrame label={group.label} titleIcon={group.titleIcon} tileStyle={tileStyleOf(useTileEnvironment().tileStyle, group.style)} />;
}
